import './_logoSVG.scss';

export default function LogoSVG() {
  return (
    <div className="loading-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        width="244.000000pt"
        height="181.000000pt"
        viewBox="0 0 244.000000 181.000000"
        preserveAspectRatio="xMidYMid meet"
        className="logo-svg"
      >
        <g
          transform="translate(0.000000,181.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path
            d="M840 1665 c0 -305 -72 -461 -254 -546 -96 -45 -192 -59 -402 -59 l-184 0 0 -144 0 -143 208 -6 c228 -7 296 -18 393 -67 117 -60 192 -165 224 -316 9 -44 15 -127 15 -226 l0 -158 165 0 165 0 0 133 c0 305 -63 502 -206 642 -35 35 -91 77 -128 96 -36 19 -66 37 -66 41 0 4 28 22 62 40 122 65 224 182 274 314 41 109 56 199 61 377 l6 167 -167 0 -166 0 0 -145z"
          />
          <path
            d="M1283 1628 c8 -263 52 -415 156 -546 47 -59 146 -137 204 -160 20 -8 37 -19 37 -23 0 -5 -28 -23 -62 -40 -40 -20 -90 -59 -139 -108 -142 -142 -199 -323 -199 -633 l0 -118 165 0 165 0 0 163 c0 182 12 253 60 347 53 106 141 175 269 213 54 16 107 21 284 24 l217 5 0 143 0 142 -207 6 c-170 5 -222 10 -283 27 -99 28 -161 63 -214 120 -96 103 -126 210 -126 452 l0 168 -166 0 -167 0 6 -182z"
          />
        </g>
      </svg>
    </div>
  );
}
